import { cva as e } from "class-variance-authority";
// src/design/forms/switch/style.ts
var t = e(["relative inline-flex items-center gap-1 cursor-pointer group overflow-anchor-none"], {
	variants: { disabled: {
		true: "cursor-not-allowed opacity-80",
		false: ""
	} },
	defaultVariants: { disabled: !1 }
}), n = e([
	"relative inline-flex items-center shrink-0 rounded-full",
	"bg-accent transition-colors duration-normal",
	"data-[state=checked]:bg-primary",
	"data-[focus-visible]:outline-[0.125rem]",
	"data-[focus-visible]:outline-transparent",
	"data-[focus-visible]:shadow-[0_0_0_3px_color-mix(in_srgb,var(--ring)_50%,transparent)]",
	"data-[disabled]:cursor-not-allowed",
	"data-[invalid]:bg-destructive/10",
	"data-[invalid]:data-[state=checked]:bg-destructive"
], {
	variants: { size: {
		sm: "h-5 w-9",
		md: "h-6 w-11",
		lg: "h-7 w-12"
	} },
	defaultVariants: { size: "md" }
}), r = e(["pointer-events-none block rounded-full", "bg-back shadow-sm transition-transform duration-normal"], {
	variants: { size: {
		sm: "h-4 w-4 translate-x-0.5 data-[state=checked]:translate-x-[1.125rem]",
		md: "h-5 w-5 translate-x-0.5 data-[state=checked]:translate-x-[1.375rem]",
		lg: "h-6 w-6 translate-x-0.5 data-[state=checked]:translate-x-[1.375rem]"
	} },
	defaultVariants: { size: "md" }
}), i = e(["text-sm font-medium text-foreground", "data-[disabled]:text-muted-foreground"], {
	variants: { disabled: {
		true: "text-muted-foreground",
		false: ""
	} },
	defaultVariants: { disabled: !1 }
}), a = e("text-xs text-muted-foreground"), o = e("text-xs text-destructive font-medium"), s = (e) => ({
	root: (e) => t(e),
	control: () => n({ size: e?.size }),
	thumb: () => r({ size: e?.size }),
	label: (e) => i(e),
	helperText: () => a(),
	errorText: () => o()
});
export { n as controlStyles, o as errorTextStyles, s as getStyles, a as helperTextStyles, i as labelStyles, t as rootStyles, r as thumbStyles };

//# sourceMappingURL=style.js.map